export default {
  title: 'Stoliki',
  count_one: '{{count}} stolik',
  count_few: '{{count}} stoliki',
  count_many: '{{count}} stolików',
  count_other: '{{count}} stolika',
  filtered_count: '{{shown}} z {{count}} stolików',
  intro:
    'Każdy stolik ma własny link i kod QR. Goście, którzy go zeskanują, zamawiają do tego stolika, a stolik widzisz przy każdym zamówieniu.',
  migrated: {
    title: 'Obsługa pokoi/stolików to teraz Zamawianie przy stoliku',
    description:
      'Dodaliśmy stolik dla każdej Twojej lokalizacji, nazwany jej nazwą, aby goście mogli nadal zamawiać. Zmień nazwy na odpowiadające Twoim stolikom lub dodaj kolejne.',
  },
  add: {
    label: 'Dodaj stolik',
    placeholder: 'np. 7, 1A lub Taras 2',
    button: 'Dodaj stolik',
  },
  errors: {
    empty: 'Wpisz nazwę stolika.',
    duplicate: 'Stolik o nazwie „{{name}}” już istnieje.',
    too_long: 'Nazwa stołu może mieć maksymalnie {{max}} znaków.',
  },
  columns: {
    order: 'Kolejność',
    table: 'Stolik i link',
    on: 'Wł.',
    copy: 'Kopiuj link',
    qr: 'Kod QR',
    actions: 'Akcje',
  },
  switch: {
    on: 'Wł.',
    off: 'Wył.',
  },
  buttons: {
    copy: 'Kopiuj link',
    copied: 'Skopiowano',
    download_qr: 'Pobierz kod QR',
    qr_short: 'Kod QR',
    rename: 'Zmień nazwę',
    delete: 'Usuń',
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  aria: {
    move: 'Przenieś {{name}} (klawisze strzałek)',
    switch: '{{name}} włączony',
    copy: 'Kopiuj link dla {{name}}',
    copied: 'Link skopiowany',
    download_qr: 'Pobierz kod QR dla {{name}}',
    rename: 'Zmień nazwę {{name}}',
    delete: 'Usuń {{name}}',
    more: 'Więcej dla {{name}}',
    new_name: 'Nowa nazwa dla {{name}}',
  },
  tooltips: {
    move: 'Przeciągnij, aby zmienić kolejność',
    move_disabled: 'Wyczyść wyszukiwanie, aby zmienić kolejność',
  },
  rename_hint: 'Link i kod QR pozostają bez zmian.',
  no_link: 'Brak adresu sklepu',
  search: {
    placeholder: 'Szukaj stolików',
    no_results: 'Brak stolika o nazwie „{{text}}”.',
  },
  load_failed: {
    title: 'Nie udało się załadować stołów.',
    retry: 'Spróbuj ponownie',
  },
  empty: {
    title: 'Brak stolików',
    text: 'Dodaj powyżej swoje stoliki, aby uzyskać link i kod QR dla każdego. Goście nie mogą zamawiać przy stoliku, dopóki go nie dodasz.',
  },
  delete: {
    title: 'Usunąć stolik „{{name}}”?',
    warning:
      'Wydrukowane kody QR tego stolika przestaną działać. Goście, którzy go zeskanują, zostaną poproszeni o kontakt z obsługą.',
    softer: 'Aby na jakiś czas wstrzymać zamówienia przy tym stoliku, wyłącz go.',
    confirm: 'Usuń stolik',
    cancel: 'Anuluj',
  },
  announcements: {
    moved: '„{{name}}” przeniesiono na pozycję {{position}} z {{count}}.',
    instructions: 'Aby przenieść stolik, ustaw fokus na jego uchwycie i naciśnij strzałkę w górę lub w dół.',
  },
  qr_image: {
    table: 'Stolik',
  },
  toasts: {
    added: 'Dodano stolik „{{name}}”',
    renamed: 'Zmieniono nazwę „{{old}}” na „{{name}}”',
    deleted: 'Usunięto stolik „{{name}}”',
    switched_on: 'Włączono „{{name}}”',
    switched_off: 'Wyłączono „{{name}}”',
    failed_to_save: 'Nie zapisano. Spróbuj ponownie.',
    failed_to_reorder: 'Nowa kolejność nie została zapisana. Spróbuj ponownie.',
    failed_to_download_qr: 'Nie udało się zapisać kodu QR. Spróbuj ponownie.',
    copy_failed: 'Nie udało się skopiować linku. Spróbuj ponownie.',
  },
};
